module.exports = __webpack_public_path__ + "static/img/nhkworld.fe76a5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/media/nhkworld.jpg
// module id = 3bjJ
// module chunks = 0